import Section from '../Section';
import QuantityControls from '../global/QuantityControls';

export default class Cart extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.quantityControls = new QuantityControls(
      this.theme,
      this.element,
      true
    );
  }
}
